import { topics } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200' },
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200' },
};

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">热议话题</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">影迷们正在热烈讨论的高清电影电视剧热门话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => {
            const c = colorMap[topic.color] || colorMap.primary;
            return (
              <div
                key={idx}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full ${c.bg} ${c.text} border ${c.border} cursor-pointer hover:scale-105 transition-transform`}
              >
                <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
                <span className="text-xs opacity-70 whitespace-nowrap">{topic.count} 讨论</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}